export default {
    bind(el, binding) {
        // 确保在 DOM 渲染后获取
        setTimeout(() => {
            // 寻找 el-select 的下拉列表的滚动容器
            const scrollWrap = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
            if (scrollWrap) {
                scrollWrap.addEventListener('scroll', function () {
                    // 判断是否滚动到底部
                    const condition = this.scrollHeight - this.scrollTop <= this.clientHeight + 1;
                    if (condition) {
                        binding.value(); // 触底时执行绑定的方法
                    }
                });
            }
        }, 0);
    }
}
